import useSWRInfinite, { type SWRInfiniteKeyLoader } from 'swr/infinite';
import { useStore } from 'react-redux';
import { useServices } from '@packages/shared/core/common/hooks';
import { Services } from '@packages/shared/core/common/context';
import { RootInitialState } from '@packages/shared/core/common/store/rootReducer';
import { QueryCacheInfiniteProviderOptions } from '../entities';

type UseCachedQueryInfiniteExtra = {
  services: Services;
  getState: () => RootInitialState;
};

type CachedQueryFetcherCreator<Data, Key> = (ctx: UseCachedQueryInfiniteExtra) => (key: Key) => Promise<Data>;

export const useCachedQueryInfinite = <Data, Key, Error = { message: string }>(
  key: SWRInfiniteKeyLoader<Data>,
  fetcherCreator: CachedQueryFetcherCreator<Data, Key>,
  options?: QueryCacheInfiniteProviderOptions<Data, Error>,
) => {
  const store = useStore();
  const services = useServices();

  return useSWRInfinite<Data, Error>(key, fetcherCreator({ services: services, getState: store.getState }), options);
};
